import { DynamicFormV2Palette } from "@mui/material";

export type FormDrawerComponentTokenType = {
  backgroundColor: string;
  backdropColor: string;
  borderColor: string;
  navigationIconColor: string;
  navigationIconDisabledColor: string;
  closeIconColor: string;
};

export const assignDrawerComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
): FormDrawerComponentTokenType => {
  const isDark = mode === "dark";
  return {
    backgroundColor: isDark ? formsPalette.surface.intense : formsPalette.surface.supershy,
    backdropColor: isDark ? "rgba(0, 0, 0, 0.8)" : "rgba(0, 0, 0, 0.4)",
    borderColor: formsPalette.border.moderate,
    navigationIconColor: formsPalette.text.moderate,
    navigationIconDisabledColor: formsPalette.text.supershy,
    closeIconColor: formsPalette.text.moderate,
  };
};
